<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-teamleader-subnav></app-teamleader-subnav>
    </app-sidebar>

    <app-content>
        <app-teamleader-not-logged-in (credentialsIsset)="checkCredentials($event)"></app-teamleader-not-logged-in>

        <div *ngIf="isset">
            <div class="app__title">
                <h1>Employees Overview</h1>
            </div>

            <app-searchbar [(value)]="filter"></app-searchbar>

            <div *ngIf="this.isLoading">
                <app-loading-message></app-loading-message>
            </div>

            <div
                class="m-t-4"
                *ngIf="!this.isLoading">
                <table
                    class="table-view"
                    *appIsPermitted="{
                        module: 'TEAMLEADER',
                        operator: 'AND',
                        actions: ['READ']
                    }">
                    <thead>
                        <th>Name</th>
                        <th>Function</th>
                        <th>Email</th>
                        <th>Language</th>
                        <th>Telephone</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of this.teamleaderUsers$ | async | filterBy: ['first_name', 'last_name']:filter">
                            <td>{{ user.first_name }} {{ user.last_name }}</td>
                            <td>{{ user.function }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ user.language }}</td>
                            <td>
                                <p *ngFor="let phone of user.telephones">
                                    {{ phone.number }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </app-content>
</app-app-holder>
